<template>
  <TTooltip
    :hidden="!tooltip || disabled"
    :value="tooltip"
    :top="tooltip_direction === 'top'"
    :right="tooltip_direction === 'right'"
    :bottom="tooltip_direction === 'bottom'"
    :left="tooltip_direction === 'left'"
  >
    <button
    :class="`ticon-button ${is_clicked ? 'color-3': ''} ${!disabled ? 'hover-me': ''}`"
      :style="`
        width: ${size || 36}px;
        height: ${size || 36}px;
      `"
      v-ripple
      :disabled="disabled"
      @click.stop="$emit('clickIcon')"
    >
      <TIcon
        :name="icon"
        :size="size - 12 || 24"
        :color="getColor(color)"
        :is_disabled="disabled"
      />
    </button>
  </TTooltip>
</template>

<script>
  import TIcon from '@/components/Taktify/TIcon.component.vue'
  import TTooltip from '@/components/Taktify/TTooltip.component.vue'
  import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    props: [
      'icon',
      'tooltip',
      'is_clicked',
      'color',
      'size',
      'disabled',
    ],

    components: {
      TIcon,
      TTooltip,
    },

    mixins: [
      TColor,
    ],

    computed: {
      tooltip_direction() {
        let a = this.$attrs;
        if(a.top !== undefined) {
          if(a.top || a.top === '')
            { return 'top'; } }
        if(a.right !== undefined) {
          if(a.right || a.right === '')
            { return 'right'; } }
        if(a.left !== undefined) {
          if(a.left || a.left === '')
            { return 'left'; } }

        return 'bottom';
      },
    },
  }
</script>
<style>
.ticon-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: background-color 0.1s ease-in-out;
  position: relative;
}
.hover-me:hover {
  background-color: #88888840;
}
</style>
